export const nestedProp = (object, nestedRoute) => {
  const reducer = (obj, prop) => {
    return typeof obj === "undefined" || obj === null ? obj : obj[prop];
  };
  return nestedRoute.split(".").reduce(reducer, object);
};

// export const allNestedPropsExists = (objectsAndRoutesArray) => {
//   let returnValue = true;
//   objectsAndRoutesArray.some((objectAndRoute) => {
//     if (!nestedProp(objectAndRoute.object, objectAndRoute.route)) {
//       returnValue = false;
//       return true;
//     }
//   });
//   return returnValue;
// };
